<template>
  <p class="text-muted mb-20">Receitas, taxas e agendamentos dos usuários que você pode ver. Despesas são dados gerais da empresa.</p>
  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-3">
    <input
      v-model="search_date"
      id="basicCalendar"
      type="text"
      class="form-control datepicker"
      placeholder="Selecione a data"
    />
  </div>
  <div class="row">
    <div class="col-12">
      <CardsFinancialManagement />
    </div>
    <div class="col-xxl-12">
      <ExpenseAmount />
    </div>
    <div class="col-xxl-12">
      <IncomingAmount />
    </div>
  </div>
</template>

<script>

import { defineComponent } from "vue";
import ExpenseAmount from "../../components/Financial/ExpenseAmount.vue";
import IncomingAmount from "../../components/Financial/IncomingAmount.vue";
import CardsFinancialManagement from "../../components/Financial/CardsFinancialManagement.vue";
import { mapActions, mapGetters } from 'vuex';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

export default defineComponent({
  name: "FinancialManagementPage",
  data(){
    return {
      search_date: null,
      fp: null,
      intervalId: null,
    }
  },
  components: {
    IncomingAmount,
    ExpenseAmount,
    CardsFinancialManagement
  },
  computed: {
    ...mapGetters(['getEmployeeMetricsScope']),
  },
  watch: {
    getEmployeeMetricsScope(value) {
      if (value) this.refreshFinancialManagement({ page: 1 });
    },
  },
  methods: {
    ...mapActions([
      "refreshFinancialManagement"
    ]),
  },
  mounted() {
    
    this.fp = flatpickr("#basicCalendar", {
      locale: Portuguese,
      plugins: [
        new monthSelectPlugin({
          shorthand: true,
          dateFormat: "m/Y",
          altFormat: "F Y",
          theme: "dark"
        })
      ],
      altInput: true,
      onChange: (selectedDates, dateStr) => {
        if (!selectedDates.length) return;
        this.search_date = dateStr;

        const date = this.search_date.split('/');
        const month = date[0];
        const year = date[1];

        this.refreshFinancialManagement({ month, year, page: 1 });
      }
    });
    
    this.refreshFinancialManagement({ month: null, year: null, page: 1 });
    this.intervalId = setInterval(() => this.refreshFinancialManagement(), 30000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    this.fp?.destroy();
  },
});
</script>
